import * as Sentry from '@sentry/react';
import { createBrowserRouter } from 'react-router';
import { appRoutes } from './routes';

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);
export const router = sentryCreateBrowserRouter(appRoutes);
